export default "<item>{{layer_id}}_{{unique_signature}}</item>";